import { MessageCircle } from "lucide-react";
import { WA_DEFAULT } from "../data/site";

export const FloatingWhatsApp = () => (
  <a
    href={WA_DEFAULT}
    target="_blank"
    rel="noreferrer"
    data-testid="floating-whatsapp-button"
    aria-label="Chat with Shivaay Consultant on WhatsApp"
    className="wa-pulse group fixed bottom-6 right-5 z-50 flex items-center gap-3 rounded-full bg-[#25D366] p-4 text-[#062E17] shadow-[0_8px_32px_rgba(37,211,102,0.4)] transition-transform hover:scale-105 sm:right-8"
  >
    <MessageCircle className="relative h-6 w-6" />
    <span className="relative hidden text-sm font-bold sm:block">Chat with us</span>
  </a>
);

export default FloatingWhatsApp;
